const en = {

    efficiency: {
        item1: "One-stop service",
        item2: "Quick processing",
        item3: "All day support"
    },


    menu: {
        solution: 'Solutions',
        solution1: 'Global cross-border acquiring',
        solution2: 'Merchant Account Management Platform',
        solution3: 'Global cross-border payments',
        solution4: 'Multi scenario access',
        aboutus: 'About',
        privacypolicy: 'Privacy Policy',
        AmlPolicy: 'AML/KYC Policy',
        technicalaccess: 'Documentation',
        technicalaccess1: 'Collection Documents',
        technicalaccess2: 'Disbursement Documents',
        technicalaccess3: 'Subscription Documents',
        technicalaccess4: 'FAQs',


        pricinginformation: 'Pricing Information',
        contactus: 'Contact',
        contactusmessage: 'Contact us to obtain a free account',
        companyintroduction: 'Company Introduction',
        knowlegeHub: 'Knowledge Hub',
        termofUse: 'Terms of Use',
        companyMoments: 'Company Moments',

    },
    globalCollection: 'Global Collection',
    solutions: {
        title1: 'Transactions without borders',
        content1: 'Achieve one-stop integration with Unionwallex and accept global payments easily',

        title2: 'Easy integration for local payments, bringing more profits to you',
        cardtitle1: '\n' +
            'Covering over 100 countries and regions, 10+languages, and 10+currencies',
        cardcontent1: 'Unionwallex has high penetration rates in emerging markets, providing more localized payment services for your users.',

        cardtitle2: '\n' +
            'Support global 100+mainstream payment methods',
        cardcontent2: 'Covering the most mainstream payment methods in the local area, such as credit cards, electronic wallets, offline branches, telecommunications operators, etc., solving the problem of multiple markets and channels at once.',

        cardtitle3: '\n' +
            'Provide multidimensional transaction data',
        cardcontent3: 'Provide real-time order inquiry, refund, data overview and other functions to help you better understand user transaction behavior and effectively solve the problem of customer complaint acceptance.',

        cardtitle4: '\n' +
            'Having flexible fund management strategies',
        cardcontent4: 'Provide multiple settlement cycles and solutions to achieve flexible fund allocation and solve the problem of fund turnover.',

    },
    globalcrossborderpay: {
        title1: 'Easy borderless payouts',
        content1: 'Send payouts to the local accounts of your users and partners.',

        title2: 'Quick, convenient batch payment service.',
        cardtitle1: '\n' +
            '\n' +
            'Popular local payment methods',
        cardcontent1: 'Popular local payment methods available, encompassing digital wallets and bank transfers.',

        cardtitle2: '\n' +
            'Lower costs and faster delivery',
        cardcontent2: 'Integration-free disbusements, batch operations, and instant transfer are available.',

        cardtitle3: '\n' +
            'High-Success batch payments',
        cardcontent3: 'Success rates of small, highly-concurrent payments up to 98%.',

        cardtitle4: '\n' +
            'Flexible and caring value-added services',
        cardcontent4: 'Flexible and caring value-added services.',


        title3: 'Varied integration plans and minimized labour costs',
        cardtitl5: 'Scenario 1: No integration needed - available once your account is registered',
        cardcontent5: 'Make development-free batch payments to your partners via the Merchant Dashboard to significantly improve your efficiency.',

        cardtitl6: 'Scenario 2: API integration - completed within one day',
        cardcontent6: 'After API integration, payments are made automatically via your app or backend system to reduce your operating costs.',


        title4: 'Unionwallex supports local disbursement solutions in multiple countries',
        HongKong: 'China HongKong',
        Brazil: ' Brazil',
        Mexico: ' Mexico',
        Peru: ' Peru',
        India: ' India',
        Philippines: ' Philippines',


        title5: 'Disbursement process\n',
        subtitle51: 'Collect user account info\n',
        subtitle52: 'Submit disbursement requests\n',
        subtitle53: 'Risk detection\n',
        subtitle54: 'Transfer completed\n',
    },
    showtitle: 'Accept payments globally with free integration',
    showcontent: 'With an in-depth understanding of payment habits around the world, Unionwallex supports 100+ payment methods and 10+ languages, covering 10+ regions to help you open up the global market.',
    numcontent1: 'Regions',
    numcontent2: 'Languages',
    numcontent3: 'Payment Methods',
    learnmore: 'MORE',

    merchantAccountManagePlatform: {
        title1: 'Merchant account management platform',
        content1: 'Order Search, Data Analysis, Refund, Settlement, \n and more functions helping you reduce operational costs.\n' +
            '\n',

        title2: 'Multi-dimensional data available for analysis, guiding you through the path to increased revenue',
        content2: 'With Order Search, Data Export, and Data Overview, analyze current payment trends and user behaviour, adjust your sales strategies accordingly to increase your revenue.',

        title3: 'Resolve customer complaints quickly with our considerate service',
        cardtitle1: 'Self-service processing of complaints',
        cardcontent1: 'Available in 30+ countries with different time zones, supporting multiple order query conditions to locate orders effectively and meet client needs efficiently.',
        cardtitle2: 'one-on-one account manager service',
        cardcontent2: 'Free account services provided by Unionwallex\'s Account Manager, Product, and Technology teams.',

        title4: 'Flexible strategies relieving you of cash flow issues.',
        cardtitle41: 'Self-service reconciliation',
        cardcontent41: 'Complete reconciliation by exporting financial data from your Unionwallex account or downloading it from SFTP.',

        cardtitle42: 'Fund management',
        cardcontent42: 'Check your account balance at any time, allocate funds flexibly, and avoid cash flow issues.',
        cardtitle43: 'Self-service settlement',
        cardcontent43: 'Withdraw balance to your bank accounts according to your needs via self-service.',

        title5: 'The Users function enables you to manage access authorizations to the Merchant Dashboard as needed',
        cardtitle51: 'Approval process\n',
        cardcontent51: 'Customize internal disbursement and reimbursement approval procedures based on your business process.',

        cardtitle52: "Sub-account feature\n",
        cardcontent52: 'Configure different levels of authorization and disclose relevant information according to employees\' role to ensure data security.',

    },

    multiScenarioIntegration: {
        title1: 'Multi-scenario integration' +
            '',
        content1: 'Well adapted to various terminals such as mobile phones, PCs and tablets to support your different payment scenarios.\n' +
            '\n',

        title2: 'Unionwallex satisfies your multiple payment requirements\n',
        content2: 'Available for mobile phones, PCs, and tablets.\n' +
            '\n',


        cardtitle1: 'In-app payment',
        cardcontent1: 'In-app payments reduce page redirections and improve user experience.',
        cardtitle2: 'Webpage payment',
        cardcontent2: 'Browser-based Unionwallex payments work perfectly on users\' mobile devices and PCs, supporting wider application.' +
            '\n',
        cardtitle3: 'Subscription payment',
        cardcontent3: 'Recurring debits upon users\' authorization increase your sustainable revenue.' +
            '\n',

        title3: 'Unionwallex provides you with popular integration methods',
        cardtitle31: 'API integration\n',
        cardcontent31: '1. Available for mobile (Android & iOS) and webpage merchants ',
        cardcontent311: '2. The wider scope of application allows you to integrate more freely',

        cardtitle32: 'SDK integration\n',
        cardcontent32: '1. Applicable for merchants with mobile (Android) apps ',
        cardcontent321: ' 2. Fast, simple integration with a small package size for an excellent user experience',
    },

    about: {
        title1: 'About',
        content1: 'Unionwallex is committed to providing professional global online payment solutions. Based on years of deep experience in emerging markets, we provide merchants with a safer and more convenient one-stop payment experience. For many years, Unionwallex has covered mainstream payment methods in emerging markets such as Hong Kong, Brazil, the Emirates, Mexico, Peru, India, Thailand, and the Philippines, in China, and has set up local offices to gain insight into local financial and tax laws and policies, ensuring compliance for enterprises going abroad.',

        emailDesc:"Contact us via email for detailed answers and efficient communication!",
        phoneDesc:"Call us anytime for one-on-one professional answers, direct and efficient!",
        telegramDesc:"Contact us via Telegram for quick responses and anytime communication!",
        telegramBtn:"Connect",

        cardtitle: 'Brazilian Company License',
        linkbtn: 'Click to view license',

        title2: 'Company Qualification',
        content2: 'Unionwallex holds licenses issued by government regulatory agencies in multiple key markets, and we always adhere to compliance and legal regulatory enforcement to ensure the safety of customer funds.',

        title3: 'Global Local Companies',
        content3: '  Currently, companies have been established in Hong Kong, Brazil, the Emirates, Mexico, Peru, India, Thailand, the Philippines, and other places in China. To provide you with more localized professional services.',
        hongkongCompanayLisense: 'HK Company License',
        uaeCompanyLicense: 'UAE Company License',
        thailandCompanyLicense: 'Thailand Company License'

    },
    contactobj: {
        contactintro: 'Contact us for more payment information',
        title: 'Welcome to leave a message',
        target: 'We will contact you as soon as possible',
        tab1: 'Merchant cooperation',
        tab2: 'User feedback',
        applicationanme: 'apply name',
        buytime: 'Purchase time',
        userid: 'User ID',
        orderid: ' Order number',
        paytype: 'Payment method',
        currencyandamount: 'Purchase currency',
        currencyandamount2: 'Purchase amount',
        paymentscreenshot: 'Payment screenshot',
        commentplaceholder: 'Please fill in your question and we will contact you as soon as possible',

        upload: 'Upload',
        uploadlimit: 'Please upload a single file smaller than 20MB',
        uploadmessage: 'Please provide payment vouchers, deduction vouchers, and other information so that we can quickly locate your issue.',
        selectdate: 'Select Date',
    },

    message: {
        name: 'Name',
        email: 'Email',
        phone: 'Phone',
        companyname: 'CompanyName',
        link: 'CompanyWebsite / Product Link',
        comment: 'Message',
        commentplaceholder: "We'd love to hear more about your business and how we can work together.",
        agreemessage: 'You agree that we will process your personal information in accordance with the',
        privacy: 'Unionwallex privacy policy'
    },
    userfeedback: 'User Feedback',
    sendmessage: 'Send',


    // Navigation
    nav: {
        solutions: 'Solutions',
        resources: 'Resources Center',
        about: 'About Us',
        help: 'Help Center'
    },

    banner: {
        title: "Service around you!",
        title2: "Build a globally integrated cross-border payment platform!",
        desc: "UnionWallex is committed to providing e-commerce users with convenient and professional cross-border payment services, creating a comprehensive payment service system based on overseas payment service scenarios, and helping Chinese enterprises to cover the entire industrial chain of overseas production and operation.",
        more: "learn more"
    },

    pic_desc1: "Quick processing",
    pic_desc2: "One-stop service",
    pic_desc3: "All day support",

    // Buttons
    button: {
        login: 'Login',
        register: 'Sign'
    },

    // Language Selector
    language: {
        selector: 'EN-English'
    },

    // Homepage Content
    homepage: {
        title: 'Efficient Access to Global Local Payment Networks',
        description: 'UnionWallex\'s dedicated local payment network provides businesses with faster, more cost-effective, and more transparent solutions than traditional banks.',

        services: {
            item1: 'Seamlessly cover global markets, quickly reach consumers in multiple countries and regions, significantly improve conversion rates, break down cross-border payment barriers,and support business globalization expansion',
            item2: 'Intelligently optimize payment success rates, with a real-time risk control engine combined with local compliance requirements, reducing transaction failure rates while ensuring fund security and shortening the payment cycle',
            item3: 'One-stop aggregation manage ment and settlement, with full-process automation, significantly reducing operational costs and making cross-border financial management more efficient and transparent'
        },
        // services: {
        //     item1: 'Global Market Expansion - Seamlessly access consumers across multiple countries/regions, boost conversion rates by breaking cross-border payment barriers, and accelerate your globalization strategy',
        //     item2: 'Payment Success Optimization - AI-driven risk control with local compliance ensures secure transactions, reduces failure rates by 30%+, and accelerates settlement cycles',
        //     item3: 'Unified Financial Management - Automated end-to-end aggregation & settlement cuts operational costs by 40% while ensuring transparent cross-border treasury operations'
        // },



        // Statistics
        stats: {
            countriesBankAccounts: {
                value: '60+',
                unit: '',
                description: 'countries/regions to open local bank accounts'
            },
            totalTransactions: {
                value: '100 billion',
                unit: '',
                description: 'in annual global transaction volume processed'
            },
            localPayments: {
                value: '120+',
                unit: '',
                description: 'countries/regions for local payments'
            },
            acquiringCountries: {
                value: '180+',
                unit: '',
                description: 'countries/regions for merchant acquiring'
            }
        }
    },
    crossBorder: {
        title: "Comprehensive Cross-Border Value-Added Services",
        desc: "Full-process product services coverage to boost your business growth.",
        services: {
            service1: {
                title: "Global Collection, Free Access",
                content: "Support e-commerce, applications, games, short dramas, live video, digital goods and other industries, and receive payments through gateway payment, bank transfer, e-wallet, etc., covering multiple countries and regions and multiple local languages, helping you easily open up the global market."
            },
            service2: {
                title: "Cross-Border Payments, Instant Settlement",
                content: "Help customers pay salaries and dividends to local employees, creators, unions, and MCNs through local bank payments and e-wallet payments in local currencies."
            }
        },
        security: {
            title: "Secure & Compliant Operations",
            items: {
                fundSecurity: {
                    title: "Fund Security",
                    content: "We work with the world's top financial institutions to properly manage your funds and strictly follow local regulations to ensure the liquidity and security of your funds."
                },
                encryption: {
                    title: "Encryption Technology",
                    content: "Adopt SSL encryption, data encryption storage and other technologies to ensure the security of customer information during the payment process and prevent data leakage and hacker attacks."
                },
                riskMonitor: {
                    title: "Risk Monitoring & Alert",
                    content: "It can monitor abnormal behaviors and risk factors in payment transactions in real time, issue early warnings in a timely manner, and take corresponding measures to prevent and deal with them."
                },
                compliance: {
                    title: "Regulatory Compliance",
                    content: "UnionWallex strictly adheres to regulations and industry standards in the many markets around the world in which we operate."
                },
                standards: {
                    title: "Stringent Standards",
                    content: "UnionWallex strictly adheres to high international security standards and meets local regulatory requirements."
                }
            }
        },
        efficiency: {
            title: "Efficient & Convenient",
            content: "Provide a one-stop cross-border payment solution, allowing customers to complete a series of operations such as collections, payments, and account management without dealing with multiple payment institutions, simplifying business processes and improving operational efficiency.",
            content1: "By adopting advanced technical architecture and an efficient payment processing system, the platform can complete cross-border payment transactions in a short time, significantly reducing transaction cycles and improving cash flow efficiency.",
            content2: "Provide 24/7 online customer service, ready to address any issues customers encounter while using the platform, ensuring a smooth and seamless payment experience.",
        },
        customization: {
            title: "Customized Services",
            solutions: {
                enterprise: "Enterprise Custom Solutions",
                enterprise_desc: "Provide full-chain cross-border payment services including currency exchange and settlement, seamlessly integrate with global local payment methods, intelligently optimize exchange rates and compliance processes, and support efficient business expansion overseas.",
                personal: "Personalized Support",
                personal_desc: "Exclusive cross-border pay ment concierge service, offering personalized 1-on-1 global payment solutions, covering multi-currency settlement, local compliance, and risk control, with full-cycle technical support.",
                flexible: "Flexible Payment Plans",
                flexible_desc: "Intelligently adapt to over 100 local payment methods globally, supporting multi-currency and multi-scenario flexible settlements, and meeting the personalized needs of businesses for cross-border collections and payments with a single click."
            }
        }
    },

    faq: {
        title: "FAQ",
        questions:
            {
                title1: "Why do exchange rates vary for transactions on the same day?",
                content1: "We are committed to providing you with the best exchange rate service. To achieve this, we directly use the settlement rates received from payment providers (such as card organizations or local payment channels) to convert payments received in different currencies into your default settlement currency. Therefore, you may notice that different transactions on the same day use different exchange rates. This is because different payment providers use their own exchange rates, and the daily rate update cutoff time for each payment provider may differ from your settlement cycle.",
                title2: "Are international transfers subject to tax?",
                content2: "BRL will be converted to USD at the real-time exchange rate and deducted from your wallet. Example 2: You enter 1,000 USD in the 'You Send' field on the payment page and select BRL as the currency received by the recipient. Since the financial transaction tax rate in Brazil is 0.38%, the tax amount is 3.8 USD (1,000 * 0.38%).",
            }
    },
    compliance: {
        title: "Security & Compliance",
        sections:
            {
                title1: "Regulatory Compliance",
                content1: "To ensure the safety of customer funds, UnionWallex has embraced global industry regulations with a proactive attitude since its inception. We have established a high-standard international compliance team, strictly adhering to international anti-money laundering conventions and relevant laws and regulations of regulatory authorities, and taking strict actions to fulfill our responsibilities.",
                title2: "Financial Compliance",
                content2: "UnionWallex employs a professional team from an international accounting firm to conduct strict internal audits to ensure compliance. At the same time, we have established a mature and comprehensive anti-money laundering and counter-terrorism financing compliance system, conducting compliance identity verification for customers to ensure the safety of customer funds and financial transactions.",
                title3: "Procedural Compliance",
                content3: "UnionWallex's business solutions have undergone multiple compliance checks from cooperative commercial banks from overseas to China. UnionWallex customers' overseas funds are stored in reserve accounts of international top-tier clearing banks, protected by both financial regulatory authorities and banks in various countries; domestic funds are 100% handled by licensed third-party payment institutions and domestic banks. All fund operations are strictly carried out according to customer instructions."
            }
    },
    privacy: {
        title: "Privacy Protection",
        content: "UnionWallex has a technology and risk team composed of financial and IT elites, with sufficient confidence and capability to protect user privacy. In addition, UnionWallex has established a secure transaction system with industry-high standards, independently tested and evaluated by authoritative third-party institutions, strictly ensuring the safety of user information and funds. Without your authorization, UnionWallex will never disclose your information to third parties."
    },

    footer: {
        account_desc: "Contact us to get a free account",
        connect_desc: "Contact Us",
        products: "Products",
        products_global_acquiring: "Global Acquiring",
        products_global_payments: "Global Payments",
        products_global_getPay: "Get Paid Globally",
        products_risk_control_management: "Risk Control Management",
        products_foreign_exchange_management: "Foreign Exchange Management",
        products_fund_management: "Fund Management",
        solutions: "Solutions",
        solutions_acquiring: "Global cross-border acquiring",
        solutions_payments: "Global cross-border payments",
        solutions_platform: "Merchant Account Management Platform",
        solutions_access: "Multi scenario access",
        aboutUs: "About Us",
        aboutUs_company: "Introduction",
        aboutUs_news: "News",
        aboutUs_terms: "Terms of Use",
        aboutUs_join: "Contact Us",
        resources: "Resources Center",
        resources_deposit: "Acquisition Doc",
        resources_withdraw: "Payment Doc",
        resources_subscription: "Subscription Doc",
        copyright: "all rights reserved"
    },


    crossBorderAcquiring: {
        overview: {
            main_title: "Cross-Border Payment Acquiring Document",
            title: "1 Overview",
            purpose: {
                title: "1.1 Document Purpose",
                content: "This document aims to provide merchants or partners with technical integration guidelines, business process descriptions, and compliance requirements for cross-border payment acquiring, ensuring efficiency, security, and compliance."
            },
            scope: {
                title: "1.2 Scope of Application",
                content: "Applicable to all merchants, payment service providers, and related partners who conduct cross-border payments through the platform."
            }
        },
        businessProcess: {
            title: "2. Business Process",
            paymentProcess: {
                title: "2.1 Payment Process",
                steps: {
                    step1: "Users place an order and select a payment method (e.g., credit card, e-wallet, bank transfer).",
                    step2: "The payment request is sent to the payment gateway.",
                    step3: "The payment gateway performs risk control checks, currency conversion (if applicable), and routes the request to the appropriate payment channel.",
                    step4: "The payment result is returned to the merchant system."
                }
            },
            settlementProcess: {
                title: "2.2 Settlement Process",
                steps: {
                    step1: "After the transaction is completed, funds are settled to the merchant's designated account (which may involve multi-currency settlement).",
                    step2: "The settlement cycle is based on the contract agreement (e.g., T+1, T+3).",
                    step3: "Settlement reports are generated and provided to the merchant."
                }
            }
        },
        technicalIntegration: {
            title: "3. Technical Integration",
            api: {
                title: "3.1 API Interfaces",
                paymentRequest: "Payment Request API: Used to initiate payment requests, including fields such as order information, payment amount, and currency.",
                paymentNotification: "Payment Result Notification API: Asynchronously notifies the payment result (success/failure).",
                query: "Query API: Used to query the order status."
            },
            dataFormat: {
                title: "3.2 Data Format",
                content: "Request and response data are typically in JSON or XML format."
            },
            security: {
                title: "3.3 Encryption and Security",
                https: "Uses HTTPS protocol to ensure data transmission security.",
                signature: "Supports signature verification (e.g., SHA256, RSA) to prevent data tampering."
            }
        },
        compliance: {
            title: "4. Compliance Requirements",
            aml: {
                title: "4.1 Anti-Money Laundering (AML)",
                content: "Merchants must provide authentic and valid identity information (KYC). Monitor transactions and report suspicious activities."
            },
            dataProtection: {
                title: "4.2 Data Protection",
                content: "Comply with data protection regulations such as GDPR and PCI DSS. Do not store sensitive payment information (e.g., credit card CVV)."
            },
            forex: {
                title: "4.3 Foreign Exchange Management",
                content: "Comply with foreign exchange management policies of various countries to ensure legal cross-border fund flows."
            }
        },
        riskManagement: {
            title: "5. Risk Management",
            measures: {
                title: "5.1 Risk Control Measures",
                monitoring: "Real-time transaction monitoring to identify abnormal transactions (e.g., large transactions, high-frequency transactions).",
                secure3D: "Supports 3D Secure verification to enhance credit card payment security."
            },
            chargeback: {
                title: "5.2 Chargeback and Dispute Handling",
                process: "Provides a chargeback handling process.",
                evidence: "Merchants must retain transaction evidence for dispute resolution."
            }
        },
        feesAndSettlement: {
            title: "6. Fees and Settlement",
            feeStructure: {
                title: "6.1 Fee Structure",
                transactionFee: "Transaction Fee: A percentage or fixed fee charged on the transaction amount.",
                exchangeRateMargin: "Exchange Rate Margin: May be charged for currency conversion.",
                settlementFee: "Settlement Fee: Bank fees that may arise from cross-border settlements."
            },
            settlementCycle: {
                title: "6.2 Settlement Cycle",
                content: "Based on the contract agreement, typically T+1 to T+7. Supports multi-currency settlement."
            }
        },
        supportAndMaintenance: {
            title: "7. Support and Maintenance",
            technicalSupport: {
                title: "7.1 Technical Support",
                content: "Provides 7x24 technical support services. Provides API documentation, SDKs, and integration examples."
            },
            updates: {
                title: "7.2 Updates and Maintenance",
                content: "Regularly updates API versions to ensure system compatibility. Notifies merchants of system upgrades or maintenance plans."
            }
        }
    },

    crossBorderPayment: {
        overview: {
            main_title: "Cross-Border Payment Document",
            title: "1 Overview",
            purpose: {
                title: "1.1 Document Purpose",
                content: "This document aims to provide users or merchants with operational guidelines for cross-border payments, including payment processes, technical integration, fee explanations, and compliance requirements, ensuring efficient, secure, and compliant payment processes."
            },
            scope: {
                title: "1.2 Scope of Application",
                content: "Applicable to all users, merchants, and partners who conduct cross-border payments through the platform."
            }
        },
        paymentProcess: {
            title: "2. Payment Process",
            userPaymentProcess: {
                title: "2.1 User Payment Process",
                step1: "Users select goods or services and proceed to the payment page.",
                step2: "Select a payment method (e.g., credit card, e-wallet, bank transfer).",
                step3: "Enter payment information (e.g., card number, expiration date, CVV).",
                step4: "Confirm the payment amount and currency (if currency conversion is involved).",
                step5: "The payment request is sent to the payment gateway to complete the payment."
            },
            paymentResultNotification: {
                title: "2.2 Payment Result Notification",
                step1: "Upon successful payment, users receive a payment success notification.",
                step2: "The merchant system receives the payment result via asynchronous notification (Webhook)."
            }
        },
        technicalIntegration: {
            title: "3. Technical Integration",
            api: {
                title: "3.1 API Interfaces",
                paymentRequest: "Payment Request API: Used to initiate payment requests, including fields such as payment amount, currency, and recipient information.",
                paymentNotification: "Payment Result Notification API: Asynchronously notifies the payment result (success/failure).",
                query: "Query API: Used to query the payment status."
            },
            dataFormat: {
                title: "3.2 Data Format",
                content: "Request and response data are typically in JSON or XML format."
            },
            security: {
                title: "3.3 Encryption and Security",
                https: "Uses HTTPS protocol to ensure data transmission security.",
                signature: "Supports signature verification (e.g., SHA256, RSA) to prevent data tampering."
            }
        },
        compliance: {
            title: "4. Compliance Requirements",
            aml: {
                title: "4.1 Anti-Money Laundering (AML)",
                content: "Users must provide authentic and valid identity information (KYC). Monitor transactions and report suspicious activities."
            },
            dataProtection: {
                title: "4.2 Data Protection",
                content: "Comply with data protection regulations such as GDPR and PCI DSS. Do not store sensitive payment information (e.g., credit card CVV)."
            },
            forex: {
                title: "4.3 Foreign Exchange Management",
                content: "Comply with foreign exchange management policies of various countries to ensure legal cross-border fund flows."
            }
        },
        feesAndExchangeRates: {
            title: "5. Fees and Exchange Rates",
            feeStructure: {
                title: "5.1 Fee Structure",
                transactionFee: "Transaction Fee: A percentage or fixed fee charged on the payment amount.",
                exchangeRateMargin: "Exchange Rate Margin: May be charged for currency conversion.",
                bankFee: "Bank Fee: Bank fees that may arise from cross-border payments."
            },
            exchangeRate: {
                title: "5.2 Exchange Rate Explanation",
                realTime: "Real-Time Exchange Rate: Calculated based on market rates in real-time.",
                locked: "Locked Exchange Rate: Some services support locking the exchange rate to ensure a fixed payment amount."
            }
        },
        riskManagement: {
            title: "6. Risk Management",
            measures: {
                title: "6.1 Risk Control Measures",
                monitoring: "Real-time transaction monitoring to identify abnormal payments (e.g., large payments, high-frequency payments).",
                secure3D: "Supports 3D Secure verification to enhance credit card payment security."
            },
            refunds: {
                title: "6.2 Refunds and Dispute Handling",
                process: "Provides a refund process, with refund amounts returned via the original payment path.",
                dispute: "Users can initiate disputes, and merchants must provide transaction evidence to resolve disputes."
            }
        },
        supportAndMaintenance: {
            title: "7. Support and Maintenance",
            technicalSupport: {
                title: "7.1 Technical Support",
                content: "Provides 7x24 technical support services. Provides API documentation, SDKs, and integration examples."
            },
            updates: {
                title: "7.2 Updates and Maintenance",
                content: "Regularly updates API versions to ensure system compatibility. Notifies users or merchants of system upgrades or maintenance plans."
            }
        }
    },


    crossBorderPaymentSub: {
        overview: {
            main_title: "Cross-Border Payment Subscription Document",
            title: "1 Overview",
            purpose: {
                title: "1.1 Document Purpose",
                content: "This document aims to provide merchants or users with operational guidelines for cross-border payment subscription services, including subscription creation, payment processes, technical integration, compliance requirements, and fee explanations, ensuring the efficiency, security, and compliance of the subscription model."
            },
            scope: {
                title: "1.2 Scope of Application",
                content: "Applicable to all merchants, users, and partners who provide or use cross-border subscription services through the platform."
            }
        },
        subscriptionModel: {
            title: "2. Subscription Model Description",
            types: {
                title: "2.1 Subscription Types",
                fixedCycle: "Fixed Cycle Subscription: Automatically deducts payments at fixed intervals (e.g., monthly, annually).",
                usageBased: "Usage-Based Subscription: Periodically settles based on actual usage (e.g., cloud services, API call counts)."
            },
            lifecycle: {
                title: "2.2 Subscription Lifecycle",
                create: "Create Subscription: Users select a subscription plan and complete the first payment.",
                renew: "Renewal: Automatically deducts payments at the end of the subscription cycle.",
                cancel: "Cancel Subscription: Users can cancel the subscription at any time, and no further payments will be deducted.",
                expire: "Subscription Expiry: The subscription status changes to 'expired' after cancellation or payment failure."
            }
        },
        paymentProcess: {
            title: "3. Payment Process",
            firstPayment: {
                title: "3.1 First Payment",
                content: "Users select a subscription plan and complete the first payment. Payment methods include credit cards, e-wallets, bank transfers, etc."
            },
            autoRenewal: {
                title: "3.2 Auto-Renewal",
                content: "At the end of the subscription cycle, the system automatically initiates a payment request. Upon successful payment, the subscription cycle is extended."
            },
            paymentFailure: {
                title: "3.3 Payment Failure Handling",
                content: "After a payment failure, the system will attempt to retry the payment (e.g., 3 retries). If retries still fail, the subscription status changes to 'expired'."
            }
        },
        technicalIntegration: {
            title: "4. Technical Integration",
            api: {
                title: "4.1 API Interfaces",
                create: "Create Subscription API: Used to create subscription plans, including fields such as subscription cycle, amount, currency, etc.",
                notify: "Payment Notification API: Asynchronously notifies the result of each payment (success/failure).",
                cancel: "Cancel Subscription API: Used to cancel subscriptions.",
                query: "Query Subscription API: Used to query subscription status and history."
            },
            dataFormat: {
                title: "4.2 Data Format",
                content: "Request and response data are typically in JSON or XML format."
            },
            security: {
                title: "4.3 Encryption and Security",
                https: "Uses HTTPS protocol to ensure data transmission security.",
                signature: "Supports signature verification (e.g., SHA256, RSA) to prevent data tampering."
            }
        },
        compliance: {
            title: "5. Compliance Requirements",
            aml: {
                title: "5.1 Anti-Money Laundering (AML)",
                content: "Users must provide authentic and valid identity information (KYC). Regularly monitor subscription transactions and report suspicious activities."
            },
            dataProtection: {
                title: "5.2 Data Protection",
                content: "Comply with data protection regulations such as GDPR and PCI DSS. Do not store sensitive payment information (e.g., credit card CVV)."
            },
            forex: {
                title: "5.3 Foreign Exchange Management",
                content: "Comply with foreign exchange management policies of various countries to ensure legal cross-border fund flows."
            }
        },
        feesAndRates: {
            title: "6. Fees and Exchange Rates",
            feeStructure: {
                title: "6.1 Fee Structure",
                transactionFee: "Transaction Fee: A percentage or fixed fee charged on each payment amount.",
                exchangeRateMargin: "Exchange Rate Margin: May be charged for currency conversion.",
                bankFee: "Bank Fee: Bank fees that may arise from cross-border payments."
            },
            exchangeRate: {
                title: "6.2 Exchange Rate Explanation",
                realTime: "Real-Time Exchange Rate: Calculated based on market rates in real-time.",
                locked: "Locked Exchange Rate: Some services support locking the exchange rate to ensure a fixed payment amount."
            }
        },
        riskManagement: {
            title: "7. Risk Management",
            measures: {
                title: "7.1 Risk Control Measures",
                monitoring: "Real-time monitoring of subscription transactions to identify abnormal payments (e.g., large payments, high-frequency payments).",
                secure3D: "Supports 3D Secure verification to enhance credit card payment security."
            },
            refunds: {
                title: "7.2 Refunds and Dispute Handling",
                process: "Provides a refund process, with refund amounts returned via the original payment path.",
                dispute: "Users can initiate disputes, and merchants must provide transaction evidence to resolve disputes."
            }
        },
        supportAndMaintenance: {
            title: "8. Support and Maintenance",
            technicalSupport: {
                title: "8.1 Technical Support",
                content: "Provides 7x24 technical support services. Provides API documentation, SDKs, and integration examples."
            },
            updates: {
                title: "8.2 Updates and Maintenance",
                content: "Regularly updates API versions to ensure system compatibility. Notifies users or merchants of system upgrades or maintenance plans."
            }
        }
    },

    login: {
        title: 'Login',
        email: 'Email',
        password: 'Password',
        submit: 'Login',
        reset: 'Reset',
        emailRequired: 'Please enter your email',
        emailInvalid: 'Email Invalid',
        passwordRequired: 'Please enter your password',
        success: 'Login successful',
    },
    register: {
        title: 'Register',
        email: 'Email',
        password: 'Password',
        confirmPassword: 'Confirm Pwd',
        submit: 'Register',
        reset: 'Reset',
        emailRequired: 'Please enter your email',
        emailInvalid: 'Email Invalid',
        passwordRequired: 'Please enter your password',
        confirmPasswordRequired: 'Please confirm your password',
        passwordMismatch: 'Passwords do not match',
        success: 'Registration successful',
    },


    policyTitle: 'Privacy Policy',
    introduction: `Unionwallex, operated by Unionwallex Limited ("Unionwallex", "we", "our" or "us"), acts as a payment aggregator facilitating payment processing ("Unionwallex Service") for our customers (the "merchants"). During this payment processing, Unionwallex will need personal information to process specific transactions. This Unionwallex Privacy Policy describes how we collect, use, store and disclose personal information.`,

    infoCollectionTitle: 'Section 1:Information We Collect And How We Use It',
    infoCollectionItem1: 'When you make or receive a payment from the merchants who using Unionwallex Service',
    infoCollectionItem2: 'When you make an inquiry about our Unionwallex Service or otherwise interact on our website',
    infoCollectionItem3: 'When you interact with us by telephone, email and other electronic communication',
    infoCollectionItem4: 'When you attend an event with us or a third party we are working with or sign up to receive publications from us',
    infoCollectionItem5: 'When we onboard you as a merchant and interact regarding our service',
    infoCollectionItem6: 'When you provide services to us or seek to provide such services We may also process your personal information from third-party sources as necessary for the provision of Unionwallex Service. We may obtain this information from your organisation, from public sources or third parties, depending on the relevant circumstances. For example, we may obtain certain personal information about you from:',

    infoSharingTitle: 'Section 2:Information Sharing',
    infoSharingItem1: 'A merchant. If we have collected your personal information in the course of providing Unionwallex Service to that merchant, and where permitted by law to others for the purpose of providing Unionwallex Service. For example, when you make a purchase or transaction with that merchant, we make certain personal information about you available to the merchant you purchase from or transact with;',
    infoSharingItem2: 'Licensed payment service provider. We may exchange certain personal information about you to enable the provision of Unionwallex Service, such as your transaction information with the licensed payment service provider or bank as necessary to provide Unionwallex Service;',
    infoSharingItem3: 'Third parties providing services for AML/KYC checks, credit risk reduction, and other fraud and crime prevention purposes, or similar services, including financial institutions, credit reference agencies, and regulatory bodies with whom such personal information is shared;',
    infoSharingItem4: 'Courts, law enforcement authorities, regulators, government officials or other competent authorities where it is reasonably necessary for the establishment, exercise or defence of a legal or equitable claim, including in order to protect the legitimate rights and interests of you and others. Such disclosures may be necessary for us to comply with mandates from FATF and local AML/CFT requirements. We may provide your Customer ID, contact information, and any other transaction information to competent authorities;',
    infoSharingItem5: 'Service providers which we engage to process personal information for any of the purposes listed above on our behalf and in accordance with our instructions only, such as licensed payment service providers, cloud storage providers; and/or',
    infoSharingItem6: 'Prospective sellers or buyers of any of our business or assets to which we might assign or novate any of our rights and obligations; in such case we may disclose your personal information to the prospective seller or buyer of such business or assets.',
    infoSharingItem7: 'Affiliates: We may share your personal information with affiliates to provide you with payment services.Any information you provide directly to a third-party merchant, website or application is not covered by this Unionwallex Privacy Policy. We are not responsible for the privacy or security practices of merchants or other third parties with whom you choose to share your personal information directly. We encourage you to review the privacy policies of any third party to whom you choose to share your personal information directly. The personal information we collect may be transferred to and stored outside of the country you use Unionwallex Service for the purposes specified in this Privacy Policy. For example, we store all of our data, including personal information, with AWS in Singapore. Any international transfers of your personal information will be made according to appropriate safeguards under the applicable laws and regulations. If you wish to enquire further about these safeguards used, please contact us using the details set out in section 8 of this Privacy Policy. We may transfer your personal information outside of the country where you use Unionwallex Service, and where we do so we will protect personal information as required by applicable laws.',

    dataRetentionTitle: 'Section 3:How long do we keep your personal information?',
    dataRetentionContent: 'Your personal information will be retained only for as long as necessary for the purposes for which the information was collected, except where necessary to meet our legal obligations (for example, in relation to KYC/AML requirements) or to establish, exercise or defend potential legal claims or to pursue our legitimate interests.',

    userRightsTitle: 'Section 4:Your Rights',
    userRightsDesc: 'Your rights will depend on the laws which apply to you and us, but you may have:',
    userRightsItem1: 'The right to obtain access to your personal information,',
    userRightsItem2: 'To have your personal information we hold rectified or deleted',
    userRightsItem3: 'To restrict our processing of that information,',
    userRightsItem4: 'To object to our processing of personal information',
    userRightsItem5: 'To have your personal information transferred to you or another organisation, and to lodge a complaint with a relevant data protection authority',
    userRightsItemDesc: 'Where you have provided us with consent for the processing, you may be able to withdraw it. Please note that even after you have chosen to withdraw your consent, we may be able to continue to process your personal information to the extent required or otherwise permitted by law, in particular in connection with exercising and defending our legal rights or meeting our legal and regulatory obligations. To withdraw your consent or to exercise any of the rights above, if they are applicable, you should use our contact details set out in section 8 below. We must ensure that your personal information we hold is accurate and up to date, where relevant. Therefore, please advise us of any changes to your information by emailing us.',


    // Section 5: Security
    securityTitle: 'Section 5:Security',
    securityContent: 'We are concerned about safeguarding the confidentiality of your information. We employ administrative, physical and electronic measures designed to protect your Information from unauthorized access and use. Please be aware that no security measures that we take to protect your information are absolutely guaranteed to avoid unauthorized access or use of your information which is impenetrable.',
    sensitiveInfoContent: 'Sensitive Information We ask that you not send us, and you not disclose, any sensitive personal information (e.g., information related to your e-wallet password, credit or debit card password, racial or ethnic origin, political opinions, religion or other beliefs, health, sexual orientation, criminal background or membership in past organizations, including trade union memberships) through Unionwallex to us, unless such information is required by us for legal compliance checks, such as KYC/AML.',

    // Section 6: Contact
    contactTitle: 'Section 6:Contact Us',
    contactContent: "If you have any questions, complaints or comments about this Unionwallex Privacy Policy or our privacy practices, or to report any violations of the Unionwallex Privacy Policy, please contact us at: 'service&#64;Unionwallex.com'.",

    // Section 7: Changes
    changeTitle: 'Section 7:Changes to This Privacy Policy',
    changeContent: 'We may revise this Unionwallex Privacy Policy from time to time to reflect any changes to the way how we process your personal information or changing legal requirements. The most current version of the policy will govern our use of your information. Please check back frequently to see any updates or changes. This Privacy Policy was last updated on the date provided at the top of this page.',

    // Section 8: Supplemental Terms
    supplementTitle: 'Section 8:Supplemental Terms',
    supplementIntro: 'The following additional or amended terms shall apply to you if you are a user in the relevant jurisdiction specified below:',
    brazilContent: `
    <strong>1. Brazil</strong><br>
    Law No. 13,709/2018 (the Brazilian General Data Protection Law, aka “LGPD”) offers additional rights and regulations for individuals located in Brazil. Further to the information set out in sections 1, 5, 7, and 10 of this Privacy Policy, the following additional information applies to you if you are located in Brazil:<br>
    <u>Minors' Information</u>: We do not knowingly collect personal information from or about children and adolescents under the age of 18. If you are under 18, please do not attempt to use Unionwallex Service or send any personal information about yourself to us. If we learn that we have collected personal information from a child or adolescent under 18, we will delete that information as soon as possible. If you believe that a child or adolescent under 18 may have provided us personal information, please contact us.<br>
    <u>Data subject’s requests</u>: Under Article 18 of the LGPD, you have the following rights as data subject:<br>
    • Confirmation of the existence of processing activities;<br>
    • Access to your personal information;<br>
    • Correction of incomplete, inaccurate, or outdated personal information;<br>
    • Anonymization, blocking or elimination of unnecessary or excessive personal information or of information processed in noncompliance with the LGPD;<br>
    • Portability of your personal information;<br>
    • Elimination of your personal information processed with your consent;<br>
    • Information of the public and private entities with which we shared your personal information;<br>
    • Information on the possibility of not providing consent and on the consequences of the denial;<br>
    • Revocation of consent and petition against us before the National Authority for Data Protection (“ANPD”).
  `,
    indonesiaContent: `<br>
    <strong>2. Indonesia</strong><br>
    If the Services are used or accessed from within Republic of Indonesia, then the following supplemental terms shall apply and override any conflicting provisions in the Privacy Policy: <br>
    • Consent from third parties. If you provide any personal data or information of third party individuals and/or parties, you represent and warrant that you have obtained the necessary consent to do so. <br>
    • Data sharing. We will not share your information with third parties for any purposes other than the provision of Unionwallex Service specified herein, without your consent. <br>
    • Governing Language. These Privacy Policy are made in English and Indonesian language versions. In the event of any discrepancy between the English and Indonesian language versions, the English language version shall prevail.<br>
    • Parental or Guardian Consent. If you are under the age of 21, you hereby represent that you had the consent of your parent or legal guardian to use the Unionwallex Service. <br>
    • Waiver. For the purpose of termination and/or dissolution and/or rescission of the Privacy Policy, we and you hereby waive the applicability of the provisions under Article 1266 of the Indonesian Civil Code, to the extent that the court order and/or decision would otherwise be required to validly terminate and/or dissolve and/or rescind the Privacy Policy.
  `,
    philippinesContent: `<br>
    <strong>3. Philippines</strong><br>
    Supplemental terms include:<br>
    <u>Article 1 Amendment</u>: Third-party consent obligations<br>
    <u>Article 3 Revision</u>: Service provider specifications<br>
    <u>Article 5 Addition</u>: Continued processing under legal obligations
  `,
    southkoreaContent: `<br>
    <strong>4. South Korea</strong><br>
    If the Services are used or accessed from within South Korea, then the following supplemental terms shall apply and override any conflicting provisions in the Privacy Policy: After the purpose of processing of your personal information is achieved, your personal information will be transmitted to a separate database (or moved to a separate storage if your information is retained in a paper form) and retained for a certain period in accordance with Unionwallex’s internal regulations and other applicable laws and regulations before it is destroyed. Your personal information relocated to a separated database will not be used for other purposes, unless it is required under the applicable laws and regulations. When destroying your personal information, we will take reasonable and technically feasible measures to make the personal information irrecoverable. For example, electronic files that contain personal information will permanently be deleted using a technical method that makes the files irrecoverable, and any other records, print-outs, documents or any other recording media will be shredded or incinerated
  `,


    // Common Terms
    common: {
        plusSign: '+',
        example:'Example'
    }
};

export default en;
